import { interval } from 'rxjs/observable/interval';
import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

@Injectable()
export class CheckForUpdateService {

  constructor(updates: SwUpdate) {
    interval(6 * 60 * 60).subscribe(() => updates.checkForUpdate());
  }
}


// WEBPACK FOOTER //
// ./src/app/service/check-for-update.service.ts